export const SET_USER_CUSTOMER = 'SET_USER_CUSTOMER';
export const SET_PRIVILEGES = 'SET_PRIVILEGES';
